import { useTranslation } from 'react-i18next';
import { Typography } from 'app/components/ui';
import { i18n } from 'shared/i18n';
import './Footer.scss';
import { TagWithMetadata } from 'entities/tag';
import { useTagInfoContinuation } from './useTagInfoContinuation';
import { ScopeToggle } from './ScopeToggle';

interface TagInfoFooterProps {
  selectedTag: TagWithMetadata | null;
  isContentMarked: boolean;
  documentTags: TagWithMetadata[];
  onCancel?: () => void;
}

export const TagInfoFooter = ({ selectedTag, isContentMarked, documentTags, onCancel }: TagInfoFooterProps) => {
  const { t } = useTranslation('tag');

  const { handleContinuation, handleStandalone, handleCancel, hasTarget, canContinue, continueDisabledHint, showScopeToggle, scopeAxis, scope, setScope } =
    useTagInfoContinuation({
      selectedTag,
      isContentMarked,
      documentTags,
      onCancel,
    });

  if (!selectedTag) return null;

  const description = continueDisabledHint ? i18n(continueDisabledHint) : hasTarget ? t('footer.ready.to.continue') : t('footer.mark.content.to.continue');

  return (
    <footer className="tags-footer bg-white">
      <div className="tags-footer__info">
        <Typography variant="body-3" color="#717077" fontWeight="semibold">
          {t('info.title')}
        </Typography>

        <Typography variant="body-7" fontWeight="light">
          {description}
        </Typography>
      </div>

      {showScopeToggle && <ScopeToggle scope={scope} onChange={(s) => setScope?.(s)} axis={scopeAxis} />}

      <div className="tags-footer__actions">
        <button className="btn btn-primary tags-footer__button" onClick={handleContinuation} disabled={!canContinue}>
          {t('continue')}
        </button>
        <button className="btn btn-secondary tags-footer__button" onClick={handleStandalone} disabled={!hasTarget}>
          {t('footer.standalone')}
        </button>
        <button className="btn btn-link tags-footer__button" onClick={handleCancel}>
          {t('footer.cancel')}
        </button>
      </div>
    </footer>
  );
};
